//错误信息分组
function groupErrors(data: any) {
  // 用对象做分组容器：key = name
  const group = {};

  data.forEach((item: any) => {
    const { name, type, field, fieldName, eleTypeName } = item;

    // 如果该 name 还没有分组，初始化
    if (!group[name]) {
      group[name] = {
        name,
        type,
        field: [],
        fieldName: [],
        eleTypeName,
      };
    }

    const target = group[name];

    // 自动去重：只添加不存在的字段
    if (!target.field.includes(field)) {
      target.field.push(field);
    }
    if (!target.fieldName.includes(fieldName)) {
      target.fieldName.push(fieldName);
    }
  });
  // 把分组对象转成数组返回
  return Object.values(group);
}

//返回元件分类名称
const getElementTypeName = (t: string) => {
  let eleName = "";
  if (t === "DistilStrict") {
    eleName = "塔";
  } else if (t === "ShellAndTubeExchanger") {
    eleName = "换热器";
  } else if (t === "pump" || t === "Pump") {
    eleName = "泵";
  } else if (t === "Flash2") {
    eleName = "闪蒸罐";
  } else if (t === "Splitter") {
    eleName = "分流器";
  } else if (t === "Mixer") {
    eleName = "混合器";
  }
  return eleName;
};

export const openErrorNotification = (
  validInfo: { elementsErrors: any; streamsErrors?: any },
  notificationApi: any,
  notificationKey: string,
  setSelectedItem: any,
  jsonData: any,
  selectElement?:any,
  setIsNowNeedOpenPramDrawer?:any,
) => {
  // onClose();
  let width = 500;
  const { elementsErrors, streamsErrors } = validInfo;
  let description: any = "";
  if (elementsErrors === "ok" && streamsErrors !== "ok") {
    const errors = groupErrors(streamsErrors);
    description = (
      <ul className="error-list">
        {errors.map((item: any, index: number) => {
          return (
            <li
              key={index}
              onClick={() => {
                console.log("item", item);
                setSelectedItem({
                  item_name: item.name,
                  job_id: jsonData.job_id,
                  job_name: jsonData.job_name,
                  path: [jsonData.job_name, "流股", item.name],
                  type: "stream",
                  data: jsonData.linkDataArray.find((l: any) => l.linkName === item.name),
                });
                //打开弹窗
                selectElement("link",jsonData.linkDataArray.find((l: any) => l.linkName === item.name));
                setIsNowNeedOpenPramDrawer(true);
              }}
            >
              <span className="s">{index + 1}</span>进料流股<b>【{item.name}】</b>：
              <b style={{ color: "red" }}>{item.fieldName.join(",")}</b>参数有误
            </li>
          );
        })}
      </ul>
    );
  } else if (elementsErrors !== "ok" && streamsErrors === "ok") {
    const errors = groupErrors(elementsErrors);
    description = (
      <ul className="error-list">
        {errors.map((item: any, index: number) => {
          return (
            <li
              key={index}
              onClick={() => {
                console.log("item", item);
                const node: any = jsonData.nodeDataArray.find((l: any) => l.nodeName === item.name);
                setSelectedItem({
                  item_name: item.name,
                  job_id: jsonData.job_id,
                  job_name: jsonData.job_name,
                  path: [jsonData.job_name, "单元操作", getElementTypeName(node.type), item.name],
                  category: getElementTypeName(node.type),
                  type: "element",
                  data: node,
                });
                //打开弹窗
                selectElement("node",node);
                setIsNowNeedOpenPramDrawer(true);
              }}
            >
              <span className="e">{index + 1}</span>
              <b>{item.name}</b>：<b style={{ color: "red" }}>{item.fieldName.join(",")}</b>
              {item.eleTypeName==="Splitter"?elementsErrors[index].msg:"参数有误"}
            </li>
          );
        })}
      </ul>
    );
  } else {
    // width = 1000;
    const e_errors = groupErrors(elementsErrors);
    const s_errors = groupErrors(streamsErrors);
    description = (
      // <div className="error-description">
      <ul className="error-list">
        {e_errors.map((item: any, index: number) => {
          return (
            <li
              key={index}
              onClick={() => {
                console.log("item", item);
                const node: any = jsonData.nodeDataArray.find((l: any) => l.nodeName === item.name);
                setSelectedItem({
                  item_name: item.name,
                  job_id: jsonData.job_id,
                  job_name: jsonData.job_name,
                  path: [jsonData.job_name, "单元操作", getElementTypeName(node.type), item.name],
                  category: getElementTypeName(node.type),
                  type: "element",
                  data: node,
                });
                //打开弹窗
                selectElement("node",node);
                setIsNowNeedOpenPramDrawer(true);
              }}
            >
              <span className="e">{index + 1}</span>
              <b>{item.name}</b>：<b style={{ color: "red" }}>{item.fieldName.join(",")}</b>
              参数有误
            </li>
          );
        })}
        {s_errors.map((item: any, index: number) => {
          return (
            <li
              key={index}
              onClick={() => {
                console.log("item", item);
                setSelectedItem({
                  item_name: item.name,
                  job_id: jsonData.job_id,
                  job_name: jsonData.job_name,
                  path: [jsonData.job_name, "流股", item.name],
                  type: "stream",
                  data: jsonData.linkDataArray.find((l: any) => l.linkName === item.name),
                });
                //打开弹窗
                selectElement("link",jsonData.linkDataArray.find((l: any) => l.linkName === item.name));
                setIsNowNeedOpenPramDrawer(true);
              }}
            >
              <span className="s">{e_errors.length + index + 1}</span>进料流股
              <b>【{item.name}】</b>：<b style={{ color: "red" }}>{item.fieldName.join(",")}</b>
              参数有误
            </li>
          );
        })}
      </ul>
    );
  }

  notificationApi?.warning({
    key: notificationKey,
    message: <b>参数设置错误</b>,
    description: <div style={{maxHeight:'calc(100vh - 120px)',overflowY:'auto'}}>{description}</div>,
    placement: "topRight",
    duration: 0,
    style: {
      width: width,
    },
  });

  //关闭函数
  return () => {
    if (notificationApi && notificationKey) {
      // 优先使用 close 方法，其次使用 destroy 方法
      if (typeof notificationApi.close === 'function') {
        notificationApi.close(notificationKey);
      } else if (typeof notificationApi.destroy === 'function') {
        notificationApi.destroy(notificationKey);
      } else {
        // 如果都不存在，尝试直接调用 notificationApi 自身（某些旧版本）
        console.warn('notificationApi 缺少 close/destroy 方法，无法关闭通知');
      }
    }
  };

};
